import App from './App';
export default App;
export { default as ErrorBoundary } from './ErrorBoundary';
